import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  orderBy,
  query,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../auth/firebase';

const COLLECTION = 'savedReplies';

export interface SavedReply {
  id: string;
  title: string;
  text: string;
  createdAt?: string;
}

export async function getSavedReplies(): Promise<SavedReply[]> {
  const q = query(collection(db, COLLECTION), orderBy('createdAt', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({
    id: d.id,
    title: d.data().title ?? '',
    text: d.data().text ?? '',
    createdAt: d.data().createdAt?.toDate?.()?.toISOString(),
  }));
}

export async function addSavedReply(title: string, text: string): Promise<SavedReply> {
  const ref = await addDoc(collection(db, COLLECTION), {
    title,
    text,
    createdAt: serverTimestamp(),
  });
  return { id: ref.id, title, text };
}

export async function deleteSavedReply(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTION, id));
}
